import { render, staticRenderFns } from "./FrontendPanel.vue?vue&type=template&id=3769077d&"
import script from "./FrontendPanel.vue?vue&type=script&lang=js&"
export * from "./FrontendPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports